import {useServerProps} from '@shopify/hydrogen';
import {ReactNode, useState, useEffect} from 'react';
import WhiskyAndIceLoadingFallback from './WhiskyAndIceLoadingFallback';

interface NavigationIndicatorProps {
  children: ReactNode | ReactNode[];
}

export default function NavigationIndicator({
  children,
}: NavigationIndicatorProps) {
  const [loading, setLoading] = useState(false);
  const {pending} = useServerProps();

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (pending) {
      timeout = setTimeout(() => setLoading(pending), 100);
    } else {
      setLoading(false);
    }
    return () => clearTimeout(timeout);
  }, [pending]);

  return (
    <>
      {loading && <WhiskyAndIceLoadingFallback overlay={true} />}
      {children}
    </>
  );
}
